import { styled } from "@mui/material/styles";
import { Button } from "@mui/material";

// Base button style (enforces same size)
const BaseStyledButton = styled(Button)({
  borderRadius: "8px",
  padding: "8px 16px", // consistent padding
  fontWeight: "bold",
  textTransform: "none",
  fontSize: "14px",
  minWidth: "100px",   // optional for uniform width
  height: "40px",      // 👈 force same height
  lineHeight: "1.2",   // text line height
  boxShadow: "0 2px 4px rgba(0,0,0,0.15)",
  transition: "all 0.2s ease-in-out",
  "&:active": {
    transform: "translateY(0)",
    boxShadow: "0 2px 4px rgba(0,0,0,0.15)",
  },
  "&:disabled": {
    background: "#ccc",
    color: "#f0f0f0",
    boxShadow: "none",
  },
});

// Success button (green)
export const SuccessButton = styled(BaseStyledButton)({
  background: "linear-gradient(135deg, #16a34a, #16a34a)",
  color: "#fff",
  "&:hover": {
    background: "linear-gradient(135deg, #26a17b, #1f8a70)",
    boxShadow: "0 4px 6px rgba(0,0,0,0.2)",
    transform: "translateY(-1px)",
  },
});

// Cancel button (orange)
export const CancelButton = styled(BaseStyledButton)({
  background: "linear-gradient(135deg, #ff7f50, #ff6600)",
  color: "#fff",
  "&:hover": {
    background: "linear-gradient(135deg, #ff944d, #e65c00)",
    boxShadow: "0 4px 6px rgba(0,0,0,0.2)",
    transform: "translateY(-1px)",
  },
});


export const BuildButton = styled(BaseStyledButton)(
  ({ disabled }) => ({
    background: disabled ? "#ccc" : "#0A66C2",
    color: disabled ? "#666" : "#fff",
    cursor: disabled ? "not-allowed" : "pointer",

    padding: "6px 16px",
    borderRadius: "8px",
    fontFamily: "'Roboto','Inter','Segoe UI',sans-serif",
    fontWeight: 700,
    fontSize: "0.875rem",
    letterSpacing: "0.3px",
    textTransform: "none",
    boxShadow: "none",
    transition: "background-color 0.3s ease, transform 0.1s ease",

    "&:hover": {
      background: disabled ? "#ccc" : "#064A8A",
      boxShadow: disabled ? "none" : "0 4px 6px rgba(0,0,0,0.2)",
      transform: disabled ? "none" : "translateY(-1px)",
    },
  })
);